import { render, staticRenderFns } from "./doctor-form.vue?vue&type=template&id=70c496da&scoped=true&lang=pug&"
import script from "./doctor-form.vue?vue&type=script&lang=ts&"
export * from "./doctor-form.vue?vue&type=script&lang=ts&"
import style0 from "./doctor-form.vue?vue&type=style&index=0&id=70c496da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c496da",
  null
  
)

export default component.exports